import { LayoutService } from './../../../layout/layout.service';
import { Title } from '@angular/platform-browser';
import { MiscellaneousService } from './../miscellaneous.service';
import { AppInitService } from './../../../services/app-init.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthenticationService } from './../../../authentication.service';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdmCompany } from 'src/app/models/adm-company';
import { DOCUMENT } from '@angular/common';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.less'],
})
export class ExternalLoginComponent implements OnInit, OnDestroy {
  companies: AdmCompany[];
  isLoading = false;
  email: string;
  password: string;
  companyDB: string;
  resetEmail: string;
  @Input() hideTitle = false;
  @Input() fromCount = false;
  @Input() hideButton = false;
  @Input() navigateAfter = true;
  @Output() submitCompleted = new EventEmitter();
  showCompanies: boolean;
  response: any;
  isResetVisible: boolean;
  navigationData: { moduleId; recordId } = {
    moduleId: '',
    recordId: '',
  };
  navigateAfterLogin = false;
  displayLandingPageLink = g.displayLandingPageLink;

  conditionsText = '';
  conditionsLink = '';
  androidAppLink = '';
  appleAppLink = '';

  acceptTerms = true;

  signupLink = '';
  t: string;
  fat: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private messageService: NzMessageService,
    private appInitService: AppInitService,
    private miscellaneousService: MiscellaneousService,
    private layoutService: LayoutService,
    private title: Title
  ) { }

  ngOnDestroy(): void {
    this.title.setTitle(g.getTitleSuffix());
  }

  ngOnInit(): void {
    this.t = this.activatedRoute.snapshot.params.t;
    this.fat = this.activatedRoute.snapshot.params.fat;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.email = this.activatedRoute.snapshot.queryParams.email;
    });

    this.title.setTitle(
      this.layoutService.translate('Login to the customer/supplier portal')
    );
    
    if (this.t != null && this.fat != null) {
      this.showCompanies = true;
      this.authenticationService
        .externalLogin(this.email, '', this.t, this.fat)
        .subscribe((d) => {
          this.proceedWithCompanySelection(d);
        });
    }

    // const params = this.route.snapshot.queryParams;
    if (this.navigateAfterLogin != null && this.navigateAfterLogin === true) {
      this.navigateAfterLogin = true;
      this.navigationData.moduleId = this.navigationData.moduleId;
      this.navigationData.recordId = this.navigationData.recordId;
    }

    this.miscellaneousService.getLoginConditionsData().subscribe((d: any) => {
      console.log(d);
      this.conditionsText = d.ConditionsText;
      this.conditionsLink = d.ConditionsLink;
      this.androidAppLink = d.AndroidAppLink;
      this.appleAppLink = d.AppleAppLink;

      if (this.conditionsText !== '') {
        this.acceptTerms = false;
      }
    });

    this.miscellaneousService.getSignupLink().subscribe((d: any) => {
      console.log(d);
      this.signupLink = d.SignupLink;
    });
  }

  direct(type) {
    if (type === 'e') {
      localStorage.setItem('login-type', 'e');
      this.router.navigate(['/apps/authentication/external-login']);
    } else if (type === 'i') {
      localStorage.setItem('login-type', 'i');
      this.router.navigate(['/apps/authentication/login']);
    }
  }

  submit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.submitForm();
    }
  }

  submitForm() {
    if (!this.acceptTerms) {
      this.messageService.error(
        this.layoutService.translate('Please accept the terms and conditions')
      );
      return;
    }
    this.isLoading = true;
    this.authenticationService
      .externalLogin(this.email, this.password, '', '')
      .subscribe((d: any) => {
        if (d.Success) {
          if (
            d.Error != null &&
            (d.Error?.startsWith('K_N_E_') || d.Error.includes('_#_'))
          ) {
            this.router.navigate(['/apps/authentication/2FA'], {
              queryParams: {
                isExist: !d.Error.startsWith('K_N_E_'),
                email: this.email,
              },
              state: {
                key: d.Error,
                usercode: this.email,
              },
            });
          } else {
            this.proceedWithCompanySelection(d);
          }

          this.authenticationService.initializeScripts.emit();
        } else {
          this.messageService.error(this.layoutService.translate(d.Error));
          this.isLoading = false;
        }
      });
  }

  private proceedWithCompanySelection(d: any) {
    if (d.company.length === 1) {
      this.login(d.company[0]);
    } else if (d.company.length > 1) {
      if (this.fromCount) {
        let company = d.company.find(
          (c) =>
            c.CompanyDB == g.userIdentity.CompanyDB &&
            c.ContactCode === g.userIdentity.ContactCode
        );
        if (company != null && company !== undefined) {
          this.login(company);
        } else {
          this.showCompanies = true;
          let index = 0;
          d.company.forEach((company) => {
            company.companyName = d.CompanyNames[index];
            index++;
          });
          this.response = d;
          this.isLoading = false;
        }
      } else {
        this.showCompanies = true;
        let index = 0;
        d.company.forEach((company) => {
          company.companyName = d.CompanyNames[index];
          index++;
        });
        this.response = d;
        this.isLoading = false;
      }
    } else if (!d.Success) {
      this.messageService.error(this.layoutService.translate(d.Error));
      this.router.navigate(['/apps/authentication/external-login']);
      this.showCompanies = false;
    }
  }

  login(company) {
    
    this.isLoading = true;
    this.authenticationService
      .externalLoginToCompany(
        this.email,
        this.password,
        company.ContactCode,
        company.CompanyDB,
        this.t,
        this.fat
      )
      .subscribe((d: any) => {
        if (!d.Success) {
          this.messageService.create(
            'error',
            this.layoutService.translate(d.Error)
          );
          this.submitCompleted.emit(false);
          this.isLoading = false;
        } else {
          g.setOneTimeToken('');
          localStorage.setItem(`ShowAnnouncement[${company.CompanyDB}]`, 'true');
          if (this.navigateAfterLogin) {
            this.authenticationService.afterLogin(
              d.Token,
              this.navigateAfter,
              this.document,
              this.submitCompleted,
              this.appInitService,
              true,
              true,
              this.navigationData
            );

          } else {
            this.authenticationService.afterLogin(
              d.Token,
              this.navigateAfter,
              this.document,
              this.submitCompleted,
              this.appInitService,
              true
            );
          }

          this.getThemeSettings();
          // this.isLoading = false;
        }
      });
  }

  reset() {
    if (this.resetEmail === '') {
      this.messageService.error(
        this.layoutService.translate('Please write your email!')
      );
    } else {
      this.miscellaneousService
        .SendAuthenticationRequest(this.resetEmail)
        .subscribe((d) => {
          if (d) {
            this.messageService.success(
              this.layoutService.translate(
                `An email with reset password link has been sent to [${this.resetEmail}].`
              )
            );
            this.isResetVisible = false;
          } else {
            this.messageService.error(
              this.layoutService.translate(
                `Failed to send a reset email to [${this.resetEmail}], please check with our customer service to validate your account.`
              )
            );
          }
        });
    }
  }

  showResetModal(): void {
    this.isResetVisible = true;
  }
  getThemeSettings() {
    if (g.getTitleSuffix()== 'Portal') {
      const queryId = g.getQueryId('styleQueryId');
      if (!queryId) return;
      this.layoutService.executeQuery(queryId).subscribe({
        next: (data: any[]) => {
          if (data && data.length > 0) {
            const item = data[0];

            if (item.BackgroundColor) {
              const rgb = this.hexToRgb(item.BackgroundColor);
              if (rgb) {
                g.setPrimaryColor(`${rgb.r}, ${rgb.g}, ${rgb.b}`);
              }
            }
            if (item.Logo) {
              g.setLogoUrl(item.Logo);
            }
          }
        }
      })
    }

  }
  hexToRgb(hex: string) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
  }

}
